module.exports = __webpack_public_path__ + "img/4392229720b8f712f6c351fcb5b4f22d.svg";